import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { loadingUser, signInPageLoaded, storeUserError } from "src/actions/authActions";
import { useDispatch, useSelector } from "react-redux";
import { User } from "oidc-client";
import { ExchangeIcon } from "src/assets/images/svg/ProductLogoCollection";
import { Button } from "react-bootstrap";
import { ApplicationState } from "src/store";
import userManager from "src/oidcClient/userService";

interface ISignInPageProps {
    redirectUrl?: string;
}

export const SignInPage: React.FC<ISignInPageProps> = (props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [showError, toggleError] = useState(false);
    const [showErrorDesc, toggleErrorDesc] = useState(false);
    const { errorDesc } = useSelector((state: ApplicationState) => state.userAuth);

    useEffect(() => {
        dispatch(signInPageLoaded());
    }, []);

    function getDialogDimensions(): Office.DialogOptions {
        let dimensions: Office.DialogOptions = { height: 70, width: 90, promptBeforeOpen: true };
        if (screen.height <= 768) {
            dimensions =
                Office.context.platform === Office.PlatformType.OfficeOnline
                    ? { height: 84, width: 90 }
                    : { height: 84, width: 90 };
        } else if (screen.height > 768 && screen.height <= 864) {
            dimensions =
                Office.context.platform === Office.PlatformType.OfficeOnline
                    ? { height: 70, width: 90 }
                    : { height: 70, width: 90 };
        } else if (screen.height > 864 && screen.height <= 1080) {
            dimensions =
                Office.context.platform === Office.PlatformType.OfficeOnline
                    ? { height: 70, width: 80 }
                    : { height: 70, width: 80 };
        }

        return dimensions;
    }

    const onLogin = () => {
        toggleError(false);
        dispatch(loadingUser());
        const url = `${window.location.origin}/login?isSignInDialog=true`;
        let dialog;
        Office.context.ui.displayDialogAsync(
            url,
            getDialogDimensions(),
            asyncResult => {
                dialog = asyncResult.value;
                if (asyncResult.status === Office.AsyncResultStatus.Failed) {
                    const error = asyncResult.error;
                    if (error.code == 12009) {
                        dispatch(storeUserError(error.message));
                        toggleError(true);
                        toggleErrorDesc(false);
                    }
                } else {
                    dialog.addEventHandler(Office.EventType.DialogMessageReceived, async (arg: { message: string; origin: string }) => {
                        const response: { from: string, user: string } = JSON.parse(arg.message);
                        dialog.close();
                        userManager.storeUser(User.fromStorageString(response.user));
                        userManager.events.load(User.fromStorageString(response.user));
                        navigate(props.redirectUrl ?? "/");
                    });
                }
            }
        );
    };

    const onDetailsClick = () => {
        toggleErrorDesc(!showErrorDesc);
    };

    return (
        <div className="signIn">
            <ExchangeIcon height={51} width={230} />
            <span id="signInDescription"></span>
            <div className="signInButton">
                <Button variant="primary" style={{ marginTop: "32px" }} onClick={onLogin}>
                    Sign In
                </Button>
            </div>
            <div id="error" hidden={!showError}>
                <div id="errorMessage">
                    <i className="fas fa-info-circle"> </i>
                    <span>{"We're having trouble signing you in. Please try again later."}
                        <a href="#" onClick={onDetailsClick}>Details</a>
                    </span>
                </div>
                <div id="errorMessageDetails" hidden={!showErrorDesc}>
                    <span>{"Description: " + errorDesc}
                    </span>
                </div>
            </div>

        </div>
    );
};

export default SignInPage;